export default function StarRatingIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.43469 0.690995C7.73404 -0.230315 9.03745 -0.230313 9.3368 0.690997L10.6309 4.67378C10.7648 5.0858 11.1487 5.36476 11.5819 5.36476H15.7697C16.7384 5.36476 17.1412 6.60437 16.3575 7.17378L12.9695 9.63527C12.619 9.88991 12.4724 10.3413 12.6062 10.7533L13.9003 14.7361C14.1997 15.6574 13.1452 16.4235 12.3615 15.8541L8.97353 13.3926C8.62304 13.138 8.14844 13.138 7.79796 13.3926L4.41 15.8541C3.62629 16.4235 2.57181 15.6574 2.87116 14.7361L4.16524 10.7533C4.29912 10.3413 4.15246 9.88991 3.80197 9.63527L0.414017 7.17377C-0.369697 6.60437 0.0330806 5.36476 1.0018 5.36476H5.18955C5.62277 5.36476 6.00673 5.0858 6.1406 4.67378L7.43469 0.690995Z"
        fill="#FC8415"
      />
    </svg>
  );
}
